import { apiJson, inCurrentWorkspace } from '../../lib/api'
import type { StartTask } from '../../components/TaskCentre'

// A render that runs as background work (§7m.5, h 4718-4720): a batch above
// the large-batch threshold is committed in the request and rendered after
// it, so the screen does not wait. The task watches the batch until it
// leaves Generating. Ready means the file and its hash are stored; nothing
// is downloaded here, because the first download issues the batch and that
// is a separate, deliberate step in Print history. Failed hands the reason
// back, and the identities stay held for Retry.

interface Watched {
  status: string
  audit_trail?: { event: string; error?: unknown }[]
}

export const WATCH_MS = 2000
// About ten minutes. A render still going by then is reported, not waited on
// for ever: the batch keeps its state and Print history shows it.
export const WATCH_TRIES = 300

const pause = (ms: number) => new Promise((r) => setTimeout(r, ms))

export function renderTask(source: any, id: string, labels: number, noun: string): StartTask {
  // The batch is in the workspace the task was started in: every poll goes there, not to whichever one
  // the viewer has switched to in the ten minutes it can take.
  const user = inCurrentWorkspace(source)
  const id8 = id.slice(0, 8)
  return {
    label: `Render ${id8}`,
    note: `${labels.toLocaleString('en-NZ')} committed labels, rendered in the background`,
    run: async () => {
      for (let i = 0; i < WATCH_TRIES; i++) {
        if (i) await pause(WATCH_MS)
        const b = await apiJson<Watched>(user, `/api/label-printing/batches/${id}`)
        if (b.status === 'Generating') continue
        if (b.status === 'Failed') {
          const last = [...(b.audit_trail || [])].reverse().find((e) => e.event === 'render_failed')
          const why = typeof last?.error === 'string' ? last.error : 'The render failed'
          throw new Error(`${why}. The identities are held: retry ${id8} from Print history.`)
        }
        return { note: `${id8} is ${b.status}. Download it from Print history to issue the ${noun}.` }
      }
      return { problem: `${id8} is still rendering. Its state is kept: check Print history.` }
    },
  }
}
